/**
 * Returns the Google Map instance to the specified destination coordinates.
 *
 * @param {object} options - The options for returning the map to the destination.
 * @param {object} options.map - The Google Map instance to return to the destination.
 * @param {object} options.maps - The Google Maps API object.
 * @param {object} options.center - The center coordinates of the destination.
 * @param {Function} options.onPan - The callback to be called when the map is panned to the destination.
 */
export const returnMapToDestination = ({ map, maps, center, onPan, }) => {
    map.panTo(center);
    // there is no way to know when a panTo finishes except that the map goes into idle mode
    maps.event.addListenerOnce(map, 'idle', onPan);
};
